var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(!_vm.$route.meta.link)?_c('router-view',{key:_vm.key}):_vm._e()],1),_c('transition',{attrs:{"name":"handle"}},[(_vm.$store.state.phone.showOrder)?_c('div',{staticClass:"cc-work-order"},[_c('Order')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }